import { HOVERED_ELEMENT_SETTINGS, SELECTED_ELEMENT_SETTINGS } from '../constants/item-types';

const getHoveredElementSettingsItems = (items) =>
  items.filter((item) => item.type === HOVERED_ELEMENT_SETTINGS);

const getSelectedElementSettingsItems = (items) =>
  items.filter((item) => item.type === SELECTED_ELEMENT_SETTINGS);

const getAllElementSettingsItems = (items) =>
  items.filter(
    (item) => item.type === HOVERED_ELEMENT_SETTINGS || item.type === SELECTED_ELEMENT_SETTINGS
  );

export {
  getHoveredElementSettingsItems,
  getSelectedElementSettingsItems,
  getAllElementSettingsItems,
};
